// extracted by mini-css-extract-plugin
module.exports = {"block":"postLinkBlock-module--block--2NDHt","title":"postLinkBlock-module--title--pWqCd","website":"postLinkBlock-module--website--uL4-c"};